import React from "react";

export const ArrowUp = ({ color }) => {
  return (
    <svg
      width="7"
      height="5"
      viewBox="0 0 7 5"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.37828 2.75375L4.11203 0.487499C3.77078 0.14625 3.21953 0.14625 2.87828 0.487499L0.612028 2.75375C0.0607781 3.305 0.454528 4.25 1.23328 4.25L5.76578 4.25C6.54453 4.25 6.92953 3.305 6.37828 2.75375Z"
        fill={color}
      />
    </svg>
  );
};

export const ArrowDown = ({ color }) => {
  return (
    <svg
      width="7"
      height="5"
      viewBox="0 0 7 5"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.621722 2.24625L2.88797 4.5125C3.22922 4.85375 3.78047 4.85375 4.12172 4.5125L6.38797 2.24625C6.93922 1.695 6.54547 0.75 5.76672 0.75L1.23422 0.75C0.455472 0.75 0.0704722 1.695 0.621722 2.24625Z"
        fill={color}
      />
    </svg>
  );
};

export const ArrowNext = ({ fill }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9.00021H12.17L7.29 13.8802C6.9 14.2702 6.9 14.9102 7.29 15.3002C7.68 15.6902 8.31 15.6902 8.7 15.3002L15.29 8.71021C15.68 8.32021 15.68 7.69022 15.29 7.30022L8.71 0.700215C8.32 0.310215 7.69 0.310215 7.3 0.700215C6.91 1.09021 6.91 1.72022 7.3 2.11022L12.17 7.00022H1C0.45 7.00022 0 7.45021 0 8.00022C0 8.55021 0.45 9.00021 1 9.00021Z"
        fill={fill}
      />
    </svg>
  );
};

export const ArrowBack = ({ fill, handleClick }) => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
    >
      <path
        d="M18.75 8.7501L4.7875 8.7501L10.8875 2.6501C11.375 2.1626 11.375 1.3626 10.8875 0.875099C10.4 0.387598 9.6125 0.387598 9.125 0.875099L0.887497 9.1126C0.399998 9.6001 0.399998 10.3876 0.887497 10.8751L9.1125 19.1251C9.6 19.6126 10.3875 19.6126 10.875 19.1251C11.3625 18.6376 11.3625 17.8501 10.875 17.3626L4.7875 11.2501L18.75 11.2501C19.4375 11.2501 20 10.6876 20 10.0001C20 9.3126 19.4375 8.7501 18.75 8.7501Z"
        fill={fill}
      />
    </svg>
  );
};
